import React from 'react'
import FilterCard from '../../components/filter-card'
import { UserTypeEnum } from '../../utils/enums'
import {
  AnnouncementTypeOptions,
  AnnouncementTargetUserTypeOptions,
  AnnouncementPublishStatusOptions
} from '../../utils/enums'

export const announcementFilterDefaults = {
  search: '',
  type: '',
  target_user_type: '',
  is_published: '',
  expires_at: '',
  start_date: '',
  end_date: ''
}

const AnnouncementsFilter = ({
  filters,
  onFilterChange,
  onFilterSubmit,
  onClearFilters,
  onRefresh,
  loading
}) => {
  const fields = [
    {
      type: 'input',
      name: 'search',
      placeholder: 'ANNOUNCEMENTS_FILTERS_SEARCH_PLACEHOLDER',
      icon: 'zmdi zmdi-search'
    },
    {
      type: 'select',
      name: 'type',
      placeholder: 'ANNOUNCEMENTS_FILTERS_TYPE_PLACEHOLDER',
      icon: 'zmdi zmdi-label',
      options: AnnouncementTypeOptions,
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN
    },
    {
      type: 'select',
      name: 'target_user_type',
      placeholder: 'ANNOUNCEMENTS_FILTERS_TARGET_USER_TYPE_PLACEHOLDER',
      icon: 'zmdi zmdi-accounts',
      options: AnnouncementTargetUserTypeOptions,
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN
    },
    {
      type: 'select',
      name: 'is_published',
      placeholder: 'ANNOUNCEMENTS_FILTERS_IS_PUBLISHED_PLACEHOLDER',
      icon: 'zmdi zmdi-check-circle',
      options: AnnouncementPublishStatusOptions,
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN
    },
    {
      type: 'input',
      name: 'expires_at',
      placeholder: 'ANNOUNCEMENTS_FILTERS_EXPIRES_AT_PLACEHOLDER',
      icon: 'zmdi zmdi-timer',
      inputType: 'date',
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN
    },
    {
      type: 'input',
      name: 'start_date',
      placeholder: 'ANNOUNCEMENTS_FILTERS_START_DATE_PLACEHOLDER',
      icon: 'zmdi zmdi-calendar-note',
      inputType: 'date',
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN
    },
    {
      type: 'input',
      name: 'end_date',
      placeholder: 'ANNOUNCEMENTS_FILTERS_END_DATE_PLACEHOLDER',
      icon: 'zmdi zmdi-calendar-check',
      inputType: 'date',
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN
    }
  ]

  return (
    <FilterCard
      filters={filters}
      onFilterChange={onFilterChange}
      onFilterSubmit={onFilterSubmit}
      onClearFilters={onClearFilters}
      onRefresh={onRefresh}
      loading={loading}
      title="ANNOUNCEMENTS_FILTERS_TITLE"
      titleHide="ANNOUNCEMENTS_FILTERS_HIDE"
      titleShow="ANNOUNCEMENTS_FILTERS_SHOW"
      fields={fields}
      defaultFilters={announcementFilterDefaults}
      autoSubmitFields={['type', 'target_user_type', 'is_published']}
    />
  )
}

export default AnnouncementsFilter


